/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Ai2OLMoE = ({ color = 'primary', aspectRatio = '1119/133', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Ai2OLMoE" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Ai2OLMoE, Ai2OLMoE as default };
